import * as type from './type'

export const toggleNavigation = () => ({
    type: type.TOGGLE_NAVIGATION,
})





// WEBPACK FOOTER //
// ./src/modules/layout/state/action.js